module.exports = __webpack_public_path__ + "static/media/jeff.e5e4a979.jpg";